<span [matTooltip]="unit_name" *ngIf="unit_name">
  <ng-container [ngSwitch]="unit_name">
    <img
      *ngSwitchCase="'#'"
      src="./assets/Icons/hashtag.svg"
      alt="#"
      [ngStyle]="{
        width: (15 * scale).toString() + 'px',
        height: (15 * scale).toString() + 'px'
      }"
    />
    <img
      *ngSwitchCase="'%'"
      src="./assets/Icons/percentage.svg"
      alt="%"
      [ngStyle]="{
        width: (15 * scale).toString() + 'px',
        height: (15 * scale).toString() + 'px'
      }"
    />
    <img
      *ngSwitchCase="'Percentage'"
      src="./assets/Icons/percentage.svg"
      alt="%"
      [ngStyle]="{
        width: (15 * scale).toString() + 'px',
        height: (15 * scale).toString() + 'px'
      }"
    />
    <img
      *ngSwitchCase="'Hours'"
      src="./assets/Icons/hourglass.svg"
      alt="Hours"
      [ngStyle]="{
        width: (20 * scale).toString() + 'px',
        height: (20 * scale).toString() + 'px'
      }"
    />
    <img
      *ngSwitchCase="'Time'"
      src="./assets/Icons/clock.svg"
      alt="Time"
      [ngStyle]="{
        width: (15 * scale).toString() + 'px',
        height: (15 * scale).toString() + 'px'
      }"
    />
    <img
      *ngSwitchCase="'$'"
      src="./assets/Icons/dollar.svg"
      alt="$"
      [ngStyle]="{
        width: (15 * scale).toString() + 'px',
        height: (15 * scale).toString() + 'px'
      }"
    />
    <img
      *ngSwitchCase="'Days'"
      src="./assets/Icons/days.svg"
      alt="Days"
      [ngStyle]="{
        width: (20 * scale).toString() + 'px',
        height: (20 * scale).toString() + 'px'
      }"
    />
    <img
      *ngSwitchCase="'Years'"
      src="./assets/Icons/year.svg"
      alt="Years"
      [ngStyle]="{
        width: (20 * scale).toString() + 'px',
        height: (20 * scale).toString() + 'px'
      }"
    />
    <span *ngSwitchDefault>({{ unit_name }})</span>
  </ng-container>
</span>
